// @ts-nocheck
import hasWindow from "@src/utils/hasWindow";
declare global {
  interface Window {
    ___isWebView?: boolean;
  }
}
const isWebView = (): boolean => {
  if (!hasWindow()) return false;
  //
  if (typeof window.___isWebView !== "undefined") {
    return window.___isWebView;
  }
  let ___isWebView = false;
  // webapps URL params detection
  const urlParams = new URLSearchParams(window.location.search);
  const webapps = urlParams.get("webapps");
  switch (parseInt(webapps || "0")) {
    case 1: // iOS
    case 2: // Android
    case 4: // iPadOS
      ___isWebView = true;
  }
  // user agent detection
  const userAgent = navigator.userAgent || "";
  // L'usage d'un UserAgent personnalisé était difficile à implémenter sur iOS
  // sur Android, on a un custom UA
  if (userAgent.includes("WebView")) {
    ___isWebView = true;
  }
  window.___isWebView = ___isWebView;
  ___isWebView && console.info("isWebView detected");
  return ___isWebView;
};
export default isWebView;
